import { ICreateRate, IEditRatePayload, IRateListSearch } from "../../../../types/master/rateInterface";
import api from "../../../../lib/api";

export const createRateApi = async (data: ICreateRate) => {
  return await api.post(`/rate`, data);
};

export const getRateListApi = async (data: IRateListSearch) => {
  const params = new URLSearchParams();
  params.set("search", data?.search ?? "");
  params.set("service_mode", data?.service_mode ?? "");
  return await api.get(`rate/${data.page}/${data.pageLimit}?${params.toString()}`);
};


export const getRateDataByIdApi = async (id: number) => {
  return await api.get(`/rate/${id}`);
};

export const editRateDataByIdApi = async (payload: IEditRatePayload) => {
  return await api.put(`/rate/${payload.id}`, payload.data);
};
